// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ca2e9bf","239":"24ee237e","455":"732cf711","762":"f6eb3a98"}[chunkId] + ".chunk.js";
};